var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_300469)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 3.83529C3.6 3.37529 3.9584 3.00195 4.4 3.00195H11.6C12.0416 3.00195 12.4 3.37529 12.4 3.83529H15.6C16.0416 3.83529 16.4 4.20862 16.4 4.66862V16.3353H17.2C17.6416 16.3353 18 16.7086 18 17.1686C18 17.6286 17.6416 18.002 17.2 18.002H14.8V5.50195H12.4V17.1686C12.4 17.6286 12.0416 18.002 11.6 18.002H6H2.8C2.3584 18.002 2 17.6286 2 17.1686C2 16.7086 2.3584 16.3353 2.8 16.3353H3.6V3.83529ZM8.67071 12.8316L10.6262 10.9131C10.8579 10.6857 10.8579 10.3183 10.6262 10.091L8.67071 8.17244C8.43901 7.94512 8.0645 7.94512 7.8328 8.17244C7.6011 8.39976 7.6011 8.76719 7.8328 8.99451L8.77678 9.92065H5.79258C5.46488 9.92065 5.2 10.1805 5.2 10.502C5.2 10.8235 5.46488 11.0834 5.79258 11.0834H8.77678L7.8328 12.0095C7.6011 12.2369 7.6011 12.6043 7.8328 12.8316C7.94836 12.945 8.10006 13.002 8.25176 13.002C8.40346 13.002 8.55516 12.945 8.67071 12.8316Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_300469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bffe843b24cb5be33bf7d3e3daa3b5c0.svg";
export { ForwardRef as ReactComponent };